<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>

	<form @submit.prevent="onSubmit">

		<smart-input :error="inputErrors.name" required label='שם' name="name" v-model="form.name"></smart-input>
		<smart-input :error="inputErrors.style" label='קובץ עיצוב' name="style" v-model="form.style"></smart-input>
		<smart-input :error="inputErrors.domain" label='דומיין' name="domain" v-model="form.domain"></smart-input>
		<!--		<smart-input :error="inputErrors.view" label='עמוד תצוגה ראשוני' v-model="form.view"></smart-input>-->
		<!--		<v-checkbox-->
		<!--				v-model="form.show_updates"-->
		<!--				label="אפשרות עדכונים"-->
		<!--		></v-checkbox>-->
		<v-checkbox
			name="out_register"
			v-model="form.can_share"
			label="יכול להוציא משחקים החוצה"
		></v-checkbox>
		<v-checkbox
			name="out_register"
			v-model="form.out_register"
			:label="`הרשמה מבחוץ`"
		></v-checkbox>
    <v-checkbox
        name="games_for_all_organization"
        v-model="form.games_for_all_organization"
        :label="`המשחקים זמינים לכל המשתמשים בארגון`"
    ></v-checkbox>
		<smart-input type="number" :error="inputErrors.price" label='מחיר הרשמה' name="price" v-model="form.price"/>
		<v-file-input :error="inputErrors.logo" name="logo" type="file" label='לוגו'></v-file-input>
		<div class="form-group">
			<v-btn type="submit" color="success">שמירה</v-btn>
		</div>
	</form>
</template>


<script>
	import OrganizationModule from "src/store/modules/Organization.module";
	import FormView from "src/mixins/FormView";
  import MediaGallery from "../../packages/gallery/MediaGallery";
  import MediaGalleryBtn from "../../packages/gallery/MediaGalleryBtn";

	export default {
		props: [],
		name: "organization-form",
		components: {MediaGalleryBtn, MediaGallery},
		data() {
			return {
				form: {},

			};
		},
		mixins: [new FormView(OrganizationModule, "organization", true)],
		computed: {
			isNew() {
				return !!this.organization.id;
			}
		},
		methods: {
			getData(e) {
				let formData = new FormData(e.target);
				if (this.form.id) {
					formData.id = this.form.id;
				}
				Object.keys(this.form).forEach((key) => {
					let value = this.form[key];
					if (typeof value === "boolean") {
						formData.append(key, +value);
					} else if (Array.isArray(value)) {
						value.forEach((val) => {
							formData.append(key + "[]", val);
						});
					} else {
						formData.append(key, value);
					}
				});

				return formData;
			},
			async callSubmit(e) {
				const submit = await this.onSubmit(e);
			}
		},

	};
</script>

<style>

</style>
